import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProcessoQuestao } from '../../../models/processo-questao.model';
import { ProcessoQuestaoService } from '../../../services/processo-questao.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-processo-questao-edit',
  templateUrl: './processo-questao-edit.component.html',
  styleUrls: ['./processo-questao-edit.component.scss']
})
export class ProcessoQuestaoEditComponent extends BaseFormComponent<ProcessoQuestao> implements OnInit {

  actionLabel: string = 'Novo';

  listAtributosProcessoQuestao: any;
  typeList: string;
  activeList: string;
  decPlacesList: string;
 
  isReadOnly:boolean = false;

  constructor(
    private myService: ProcessoQuestaoService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    //public maskService: MaskService,
    //private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.listAtributosProcessoQuestao = this.activatedRoute.snapshot.data["listAtributosProcessoQuestao"];
    this.typeList = this.listAtributosProcessoQuestao["typeList"];
    this.activeList = this.listAtributosProcessoQuestao["activeList"];
    this.decPlacesList = this.listAtributosProcessoQuestao["decPlaces"];
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      title: ['', [Validators.required]],
      type_id: [1,],
      max_length: ['',],
      dec_places: [0,],
      actived: [1,],
      ref_link: ['',],
      report_title: ['',],
      tooltip: ['',],
      items: new FormArray([]),
    });

    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.isReadOnly = this.entity.isUsed;

      let items = this.entity?.items;
      if(items?.length){
        items.forEach((item=>{
          this.getFormArray().push(
           this.createFormGroup(item)
          )
        }))
      }
    }
  }  

  createFormGroup(values = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.id),
      question_id: new FormControl(values?.question_id),
      ds_value: new FormControl(values?.ds_value),
      isUsed: new FormControl(values?.isUsed),
    });
  }


  getDataCreate(): ProcessoQuestao {
    let data: ProcessoQuestao;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProcessoQuestao) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProcessoQuestao) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace([
                'pre-projeto/admin/processo-questao/',res.id
              ]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }
  voltar() {
    this.navigation.back(['pre-projeto/admin/processo-questao']);
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['pre-projeto/admin/processo-questao']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  changeTypeId(e:any){
    //this.form.get('type_id').value(e.id);
    console.log(this.form.get('type_id').value)
  }

  addNewCombo() {
    this.getFormArray().push(this.createFormGroup(1));
  }

  getFormArray(): FormArray {
    return this.form.get('items') as FormArray;
  }

  removeCombo(index: number) {
    this.getFormArray().removeAt(index);
  }
}
